import { render, staticRenderFns } from "./ElacTenantsList.vue?vue&type=template&id=07f2499a"
import script from "./ElacTenantsList.vue?vue&type=script&lang=js"
export * from "./ElacTenantsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports